var React = require('react');

function CopyIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"75","height":"75","rx":"12","fill":"#E8F1FB","key":0}),React.createElement("rect",{"x":"12.5","y":"26.5625","width":"50","height":"3.125","fill":"#135CA3","key":1}),React.createElement("rect",{"x":"12.5","y":"32.8125","width":"50","height":"3.125","fill":"#135CA3","key":2}),React.createElement("rect",{"x":"12.5","y":"39.0625","width":"50","height":"3.12499","fill":"#135CA3","key":3}),React.createElement("rect",{"x":"12.5","y":"45.3125","width":"25","height":"3.125","fill":"#135CA3","key":4})]);
}

CopyIcon.defaultProps = {"width":"75","height":"75","viewBox":"0 0 75 75","fill":"none"};

module.exports = CopyIcon;

CopyIcon.default = CopyIcon;
